import * as Sentry from "@sentry/nuxt";

export default defineNuxtPlugin({
  name: "sentry-replay-consent",
  dependsOn: ["sentry-client-integrations"],
  setup() {
    const { cookiesEnabledIds } = useCookieControl();
    let replayAdded = false;
    let stopping = false;

    watch(
      () => cookiesEnabledIds.value,
      (current) => {
        const consented = current?.includes("sentry-replay") ?? false;
        const client = Sentry.getClient();

        if (consented && !replayAdded && !stopping) {
          if (!client) {
            console.warn("[sentry-replay] User consented but Sentry client unavailable.");
            return;
          }
          try {
            client.addIntegration(
              Sentry.replayIntegration({
                maskAllText: true,
                maskAllInputs: true,
                blockAllMedia: false,
              })
            );
            replayAdded = true;
          } catch (error) {
            console.warn("[sentry-replay] Failed to add Replay integration:", error);
          }
          return;
        }

        if (consented && replayAdded) {
          const replay = client?.getIntegrationByName("Replay");
          if (replay && "start" in replay) {
            (replay as { start: () => void }).start();
          }
          return;
        }

        if (!consented && replayAdded) {
          const replay = client?.getIntegrationByName("Replay");
          if (replay && "stop" in replay) {
            stopping = true;
            (replay as { stop: () => Promise<void> })
              .stop()
              .catch((error) => {
                console.warn("[sentry-replay] Error stopping Replay:", error);
              })
              .finally(() => {
                stopping = false;
              });
          }
        }
      },
      { deep: true, immediate: true }
    );
  },
});
